import ajax from "./ajax";

export const listDstLibrary = (query) => {
  return ajax("/dst-library", { method: "GET", query });
};

export const deleteDstLibraryFile = (id) => {
  return ajax(`/dst-library/${id}`, { method: "DELETE" });
};

export const updateDstLibraryFile = (id, data) => {
  return ajax(`/dst-library/${id}`, { method: "PATCH", data });
};

export const searchDstSellers = (q) => {
  return ajax("/dst-library/sellers", { method: "GET", query: { q } });
};

// DST editor: one change to a DST applies to every product using it.
// Node API: routes/dstLibrary.js + functions/dstLibrary/replaceJob.js.

/** { file, usages: [{ id, collection, name, docs: [{ docId, blankProductId, placementDetails, hits, defaultPreview }] }] } */
export const getDstUsages = (id) =>
  ajax(`/dst-library/${encodeURIComponent(id)}/usages`, { timeout: 120000 });

/** { matches: [{ id, name, url, sameFile }] } — same bytes or same file name. */
export const checkDstDuplicate = (data) =>
  ajax("/dst-library/check-duplicate", { method: "POST", data });

/** { job, file } — job is null when no product uses the DST. */
export const startDstReplace = (id, data) =>
  ajax(`/dst-library/${encodeURIComponent(id)}/replace`, {
    method: "POST",
    data,
    timeout: 120000,
  });

export const listActiveDstReplaceJobs = () =>
  ajax("/dst-library/jobs", { query: { active: "true" } });

export const getDstReplaceJob = (jobId) => ajax(`/dst-library/jobs/${jobId}`);

export const getDstReplaceJobResults = (jobId, statuses = []) =>
  ajax(`/dst-library/jobs/${jobId}/results`, {
    query: statuses.length ? { status: statuses.join(",") } : undefined,
  });

export const cancelDstReplaceJob = (jobId) =>
  ajax(`/dst-library/jobs/${jobId}/cancel`, { method: "POST" });

export const retryFailedDstReplaceJob = (jobId) =>
  ajax(`/dst-library/jobs/${jobId}/retry-failed`, { method: "POST" });

export const dismissDstReplaceJob = (jobId) =>
  ajax(`/dst-library/jobs/${jobId}/dismiss`, { method: "POST" });

/** Save the previews the editor drew as each product's preview images. */
export const saveDstReplacePreviews = (jobId, previews) =>
  ajax(`/dst-library/jobs/${jobId}/previews`, {
    method: "POST",
    data: { previews },
    timeout: 120000,
  });
